// frontend-react/src/services/apiClient.ts
import axios from 'axios';
import { getApiBaseUrl } from '../config/api';
import { authService } from './authService';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || getApiBaseUrl(),
  withCredentials: true,
});

let isHandling401 = false;

apiClient.interceptors.request.use(config => {
  // ✅ 乾淨單一：你的 authService 本來就有 getToken()
  const token = authService.getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  res => res,
  err => {
    const status = err?.response?.status;

    // ✅ 統一處理：401 = 登入狀態失效
    if (status === 401) {
      const hasToken = !!authService.getToken();

      // 避免同時間多個 API 一起 401 → 只處理一次
      if (hasToken && !isHandling401) {
        isHandling401 = true;

        // 1) 清 token/user
        authService.removeToken();
        authService.removeUser();

        // 2) 丟事件給 UI（若你之後要在 AuthContext/頁面顯示提示）
        window.dispatchEvent(
          new CustomEvent('auth:session_invalid', {
            detail: {
              message:
                '登入狀態已失效，請重新登入後再試。\n可能原因：登入逾時／已在其他裝置登入／密碼更新後需重新登入。',
            },
          })
        );

        // 3) 導回登入頁
        window.location.href = '/login?reason=session_invalid';
      }
    }

    return Promise.reject(err);
  }
);

export default apiClient;
